import template from './commissionLanding.html';
import controller from './commissionLandingCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isMobileDevice: '<',
    parentToChildNotificationRegistration: '&',
    types: '<',
    lenders: '<',
    brokers: '<',
    default: '<',
  },
};
